<!-- 排产操作日志 -->
<style scoped="scoped" lang="scss"></style>
<style lang="scss">
.el-select .el-input {
  width: auto;
}
</style>
<style lang="scss" scoped="">
// .testMoldTable {
//   margin-top: 10px;
//   text-align: center !important;
// }

// .testMoldTable /deep/ table {
//   color: #303133 !important;
// }

// .testMoldTable /deep/ table tbody tr:first-child {
//   background-color: #909399 !important;
//   color: #FFFFFF IM !important;
// }


.container::-webkit-scrollbar {
  display: none;
}


.testMoldTable {
  margin-top: 10px;
  font-size: 12px;
  text-align: center;
  border: none !important;
}

.testMoldTable /deep/ table {
  border-collapse: collapse;
  border-color: rgb(232, 232, 232);
}

.testMoldTable /deep/ table tbody tr:first-child {
  height: 26px;
  font-size: 12px;
  background: rgb(123, 127, 128);
}

.testMoldTable /deep/ table tbody tr:not(:first-child) {
  height: 26px;
  font-size: 12px;
  color: #606672;
}

/* 查看弹窗：空射调试 tab 内容区上移，缩小与 tab 标题间距 */
.tab-pane-kongshetiaoshi {
  padding: 4px 0 12px;
  margin-top: -6px;
}

</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/trial/mould/wo/page" getKey="rows" :columns="columns">


      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shimojihuadanhao')">
            <el-input v-model="yt.conditions.planNo"></el-input>
          </el-form-item>

          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIds"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('shezuimingcheng')">
            <yi_data_select :multiple="true" :type="'mouth'" :ids.sync="yt.conditions.shootingMouthIds"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('mojumingcheng')">
            <yi_data_select :multiple="true" :type="'mould'" :ids.sync="yt.conditions.mouldIds"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('wuliaomingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIds"></yi_data_select>
          </el-form-item>


          <el-form-item :label="$t('danjuzhuangtai')">
            <yi_dictionary_select :type="'TRIAL_MOULD_WO_STATUS'" :ids.sync="yt.conditions.statusList" :multiple="true" :max="999"> </yi_dictionary_select>
          </el-form-item>

          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ createTimeStart: createTimeStart, createTimeEnd: createTimeEnd, orderBy: 'id desc' })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" type="primary" @click="yt.showEditDialog('xinzeng', null, 'w1')">
          {{ $t('xinzeng') }}
        </el-button>

      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #lilungongyika="scope">
        <yi_upload :readOnly="true" :ids.sync="scope.row.fileIds" :limit="10"></yi_upload>
      </template>
      <!-- 1-待试模,2-调试中,3-试模中,4-已完成,5-暂停中 -->
      <template #caozuo="scope">
        <el-button v-if="scope.row.status == 1 || scope.row.status == 5" type="text" @click="yt.editObj = scope.row; yt.req('POST', '/web/trial/mould/wo/start?id=' + scope.row.id)">{{ $t('kaishishimo') }} </el-button>
        <el-button v-if="scope.row.status == 1" type="text" @click="yt.showEditDialog('bianji', scope.row)">{{ $t('bianji') }} </el-button>
        <el-button v-if="scope.row.status == 2 || scope.row.status == 3" type="text" @click="yt.showEditDialog('shimojindu', scope.row, '80%'); refreshProgressDialog()">{{ $t('shimojindu') }} </el-button>
        <el-button v-if="scope.row.status == 4" type="text" @click="activeTab = '0'; yt.showEditDialog('chakan', scope.row, '80%'); refreshProgressDialog()">{{ $t('chakan') }} </el-button>
        <el-button v-if="scope.row.status == 2" type="text" @click="yt.editObj = scope.row; yt.req('POST', '/web/trial/mould/wo/pause?id=' + scope.row.id)">{{ $t('zanting') }} </el-button>
        <el-button type="text" @click="openAttachmentDialog(scope.row)">{{ $t('fujian') }}</el-button>
        <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/trial/mould/wo/delete', null, '是否删除该试模工单？删除后数据不可恢复')">{{ $t('shanchu') }} </el-button>

      </template>
    </yi_curd_table>
    <!-- 公共弹框：新增/编辑等动作共用 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body" @close="handleDialogClose">
      <!-- 新增 -->
      <template v-if="yt.editObj && yt.editObj.action === 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="'147px'" :model="yt.editObj">
          <el-form-item :label="$t('shimojihuadanhao')" required>
            <el-input v-model="yt.editObj.planNo"></el-input>
          </el-form-item>

          <el-form-item :label="$t('shezuimingcheng')" required>
            <yi_data_select :type="'mouth'" :ids.sync="yt.editObj.shootingMouthId"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('wuliaomingcheng')" required>
            <yi_data_select :type="'material2'" :ids.sync="yt.editObj.materialId"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('mojumingcheng')" required>
            <yi_data_select :type="'mould'" :ids.sync="yt.editObj.mouldId"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('shebeimingcheng')" required>
            <yi_data_select :type="'equipment'" :ids.sync="yt.editObj.equipmentId"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('lilungongyika')">
            <yi_upload :accept="'application/pdf,image/png,image/jpeg,image/gif'" :ids.sync="yt.editObj.fileIds" :limit="10">
              <div slot="limitMsg"></div>
            </yi_upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="createWo" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <!-- 编辑 -->
      <template v-else-if="yt.editObj && yt.editObj.action === 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="'147px'" :model="yt.editObj">
          <el-form-item :label="$t('shimojihuadanhao')" required>
            <el-input v-model="yt.editObj.planNo"></el-input>
          </el-form-item>

          <el-form-item :label="$t('shezuimingcheng')" required>
            <yi_data_select :type="'mouth'" :ids.sync="yt.editObj.shootingMouthId"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('wuliaomingcheng')" required>
            <yi_data_select :type="'material2'" :ids.sync="yt.editObj.materialId"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('mojumingcheng')" required>
            <yi_data_select :type="'mould'" :ids.sync="yt.editObj.mouldId"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('shebeimingcheng')" required>
            <yi_data_select :type="'equipment'" :ids.sync="yt.editObj.equipmentId"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('lilungongyika')">
            <yi_upload :accept="'application/pdf,image/png,image/jpeg,image/gif'" :ids.sync="yt.editObj.fileIds" :limit="10">
              <div slot="limitMsg"></div>
            </yi_upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="updateWo" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <!-- 试模进度查看 -->
      <template v-else-if="yt.editObj && yt.editObj.action === 'chakan'">
        <div class="dialog-scroller">
          <el-descriptions :column="3" size="mini">
            <el-descriptions-item :label="$t('wuliaomingcheng') + '/' + $t('wuliaobianma')">
              {{ yt.editObj.material && yt.editObj.material.name }} / {{ yt.editObj.material && yt.editObj.material.code }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('mojumingcheng') + '/' + $t('mujubianma')">
              {{ yt.editObj.mould && yt.editObj.mould.name }} / {{ yt.editObj.mould && yt.editObj.mould.code }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('shezuimingcheng') + '/' + $t('shezuibianma')">
              <div style="display: flex;align-items: center;">
                <p> {{ yt.editObj.shootingMouth && yt.editObj.shootingMouth.name }} / {{ yt.editObj.shootingMouth && yt.editObj.shootingMouth.code }}</p>
              </div>

            </el-descriptions-item>
            <el-descriptions-item :label="$t('danjuzhuangtai')">
              {{ $t(store.state.dictJsonAll['TRIAL_MOULD_WO_STATUS'][yt.editObj.status]) }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('shebeimingcheng') + '/' + $t('shebeibianma')">
              {{ yt.editObj.equipment && yt.editObj.equipment.name }} / {{ yt.editObj.equipment && yt.editObj.equipment.sn }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('lilungongyika')">
              <yi_upload :readOnly="true" :ids.sync="yt.editObj.fileIds" :limit="10"></yi_upload>
            </el-descriptions-item>
          </el-descriptions>
          <div style="padding: 40px 0px;">
            <el-steps :active="Number(yt.editObj.currentStep)" align-center finish-status="success">
              <el-step title="空射调试">
                <template #description>
                  <span>
                    <span v-if="yt.editObj.stepOneFinishTime">{{ dayjs(yt.editObj.stepOneFinishTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
                  </span>
                </template>
              </el-step>
              <el-step title="开始试模">
                <template #description>
                  <span>
                    <span v-if="yt.editObj.stepTwoFinishTime">{{ dayjs(yt.editObj.stepTwoFinishTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
                  </span>
                </template>
              </el-step>
              <el-step title="分段采集">
                <template #description>
                  <span v-if="yt.editObj.stepThreeFinishTime">{{ dayjs(yt.editObj.stepThreeFinishTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
                </template>
              </el-step>
              <el-step title="完成试模">
                <template #description>
                  <span v-if="yt.editObj.stepFourFinishTime">{{ dayjs(yt.editObj.stepFourFinishTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
                </template>
              </el-step>
            </el-steps>
          </div>
          <el-tabs v-model="activeTab" style="margin-top: 20px;">
            <el-tab-pane :label="$t('kongshetiaoshi')">
              <div class="tab-pane-kongshetiaoshi">
                <div style="margin: 4px 0 8px; font-weight: 600;">工艺数据</div>
                <div v-if="ksViewStepOne" class="testMoldTable" v-html="ksViewStepOne" v-watermark="watermarkText"></div>
                <div style="margin: 8px 0;font-weight: 600;">{{ $t('baojingshuju') }}</div>
                <el-table :data="(yt.editObj && yt.editObj.realTimeAlerts) ? yt.editObj.realTimeAlerts : []" size="mini" border style="width: 100%">
                  <el-table-column type="index" :label="$t('xuhao')" width="60"></el-table-column>
                  <el-table-column :label="$t('baojingxinxi')">
                    <template #default="{ row }">
                      {{ row.i18n ? $t(row.i18n) : row.code }}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('baojingshijian')" width="180">
                    <template #default="{ row }">
                      {{ row.alarmTime ? dayjs(row.alarmTime).format('YYYY-MM-DD HH:mm:ss') : '' }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div style="padding:20px 0px;">
                <div style="margin: 8px 0;font-weight: 600;">{{ $t('xiugaijilu') }}</div>
                <el-table :data="(yt.editObj && yt.editObj.editRecords) ? yt.editObj.editRecords : []" size="mini" border style="width: 100%">
                  <el-table-column :label="$t('xiugaishijian')" width="180">
                    <template #default="{ row }">
                      {{ row.updateTime ? dayjs(row.updateTime).format('YYYY-MM-DD HH:mm:ss') : '' }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="createByObject.nickname" :label="$t('xiugairen')" width="120"></el-table-column>
                  <el-table-column :label="$t('xiugaiqian')" width="180">
                    <template #default="{ row }">
                      {{ getMouthName(row.beforeShootMouthId) }}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('xiugaihou')" width="180">
                    <template #default="{ row }">
                      {{ getMouthName(row.afterShootMouthId) }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('shimogongyi')">
              <el-tabs v-model="viewCraftSubTab" style="margin-top: 10px;">
                <el-tab-pane label="历史工艺" name="history">
                  <div style="margin-bottom: 20px;">
                    <el-select v-model="currentCraftParameterId" :placeholder="$t('qingxuanze')" size="mini" @change="changeCraftId" style="width: 300px !important;">
                      <el-option v-for="item in craftParameterList" :key="item.id" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select>
                    <el-button v-if="utils.checkPower('web_test_mold_work_order_deleteCurrentCraftParameter')" @click="deleteCurrentCraftParameter()" :disabled="craftParameterList.length === 0 || !currentCraftParameterId" style="margin-left: 10px;" type="danger" size="mini">{{ $t('shanchudangqiangongyimoban') }}</el-button>
                    <el-button style="margin-left: 10px;" size="mini" type="primary" @click="exportExcel" :loading="exportExcelLoading" :disabled="craftParameterList.length === 0 || !currentCraftParameterId">{{ $t('daochu') }}</el-button>
                  </div>
                  <div style="margin-bottom: 40px;">
                    <div style="margin: 8px 0;font-weight: 600;">工艺数据</div>
                    <div class="testMoldTable" v-html="gy" v-watermark="watermarkText"></div>
                    <div v-if="ks" class="testMoldTable" v-html="ks" v-watermark="watermarkText"></div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="品质监控" name="qualityMonitor">
                  <div style="padding: 12px 0 16px;">
                    <el-table :data="viewQualityMonitorData" size="mini" border style="width: 100%" max-height="400" v-loading="viewQualityMonitorLoading">
                      <el-table-column prop="name" label="参数名称" min-width="120" fixed></el-table-column>
                      <el-table-column prop="seq1" label="1" min-width="80" align="center"></el-table-column>
                      <el-table-column prop="seq2" label="2" min-width="80" align="center"></el-table-column>
                      <el-table-column prop="seq3" label="3" min-width="80" align="center"></el-table-column>
                      <el-table-column prop="seq4" label="4" min-width="80" align="center"></el-table-column>
                      <el-table-column prop="seq5" label="5" min-width="80" align="center"></el-table-column>
                      <el-table-column prop="seq6" label="6" min-width="80" align="center"></el-table-column>
                      <el-table-column prop="seq7" label="7" min-width="80" align="center"></el-table-column>
                      <el-table-column prop="seq8" label="8" min-width="80" align="center"></el-table-column>
                      <el-table-column prop="seq9" label="9" min-width="80" align="center"></el-table-column>
                      <el-table-column prop="seq10" label="10" min-width="80" align="center"></el-table-column>
                    </el-table>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane :label="$t('fenduancaiji')">
              <div style="margin-bottom: 20px;">
                <el-select v-model="currentCraftParameterId" :placeholder="$t('qingxuanze')" size="mini" style="width: 300px !important;" @change="changeCraftId">
                  <el-option v-for="item in craftParameterList" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
                <el-button v-if="utils.checkPower('web_test_mold_work_order_deleteCurrentCraftParameter')" @click="deleteCurrentCraftParameter()" :disabled="craftParameterList.length === 0 || !currentCraftParameterId" style="margin-left: 10px;" type="danger" size="mini">{{ $t('shanchudangqiangongyimoban') }}</el-button>
                <el-button style="margin-left: 10px;" size="mini" type="primary" @click="exportExcel" :loading="exportExcelLoading" :disabled="craftParameterList.length === 0 || !currentCraftParameterId">{{ $t('daochu') }}</el-button>
              </div>
              <div style="margin-bottom: 40px;">
                <div style="margin: 8px 0;font-weight: 600;">工艺数据</div>
                <div class="testMoldTable" v-html="gy" v-watermark="watermarkText"></div>
                <div v-if="ks" class="testMoldTable" v-html="ks" v-watermark="watermarkText"></div>
              </div>
            </el-tab-pane>
          </el-tabs>

        </div>

      </template>
      <!-- 试模进度查看 -->
      <template v-else-if="yt.editObj && yt.editObj.action === 'shimojindu'">
        <div class="dialog-scroller">
          <el-descriptions :column="3" size="mini">
            <el-descriptions-item :label="$t('wuliaomingcheng') + '/' + $t('wuliaobianma')">
              {{ yt.editObj.material && yt.editObj.material.name }} / {{ yt.editObj.material && yt.editObj.material.code }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('mojumingcheng') + '/' + $t('mujubianma')">
              {{ yt.editObj.mould && yt.editObj.mould.name }} / {{ yt.editObj.mould && yt.editObj.mould.code }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('shezuimingcheng') + '/' + $t('shezuibianma')">
              <div style="display: flex;align-items: center;">
                <p> {{ yt.editObj.shootingMouth && yt.editObj.shootingMouth.name }} / {{ yt.editObj.shootingMouth && yt.editObj.shootingMouth.code }}<el-link type="primary" @click="updateShootingMouth()">{{ $t('xiugai') }}</el-link></p>
              </div>

            </el-descriptions-item>
            <el-descriptions-item :label="$t('danjuzhuangtai')">
              {{ $t(store.state.dictJsonAll['TRIAL_MOULD_WO_STATUS'][yt.editObj.status]) }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('shebeimingcheng') + '/' + $t('shebeibianma')">
              <div style="display: flex;align-items: center;">
                <p>
                  {{ yt.editObj.equipment && yt.editObj.equipment.name }} / {{ yt.editObj.equipment && yt.editObj.equipment.sn }}<el-link v-if="yt.editObj.currentStep == 1" type="primary" @click="updateEquipment()">{{ $t('xiugai') }}</el-link>
                </p>
              </div>
            </el-descriptions-item>
            <el-descriptions-item :label="$t('lilungongyika')">
              <yi_upload :readOnly="true" :ids.sync="yt.editObj.fileIds" :limit="10"></yi_upload>
            </el-descriptions-item>
          </el-descriptions>
          <div style="padding: 40px 0px;">
            <el-steps :active="Number(yt.editObj.currentStep) - 1" align-center finish-status="success">
              <el-step title="空射调试">
                <template #description>
                  <span>
                    <span v-if="yt.editObj.stepOneFinishTime">{{ dayjs(yt.editObj.stepOneFinishTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
                  </span>
                </template>
              </el-step>
              <el-step title="开始试模">
                <template #description>
                  <span>
                    <span v-if="yt.editObj.stepTwoFinishTime">{{ dayjs(yt.editObj.stepTwoFinishTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
                  </span>
                </template>
              </el-step>
              <el-step title="分段采集">
                <template #description>
                  <span v-if="yt.editObj.stepThreeFinishTime">{{ dayjs(yt.editObj.stepThreeFinishTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
                </template>
              </el-step>
              <el-step title="完成试模">
                <template #description>
                  <span v-if="yt.editObj.stepFourFinishTime">{{ dayjs(yt.editObj.stepFourFinishTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
                </template>
              </el-step>
            </el-steps>
          </div>


          <div v-if="yt.editObj && (yt.editObj.currentStep == 1)">
            <div style="padding:20px 0px;">
              <div style="margin: 8px 0;font-weight: 600;">工艺数据</div>
              <div v-if="ks" class="testMoldTable" v-html="ks" v-watermark="watermarkText"></div>
              <div style="margin: 8px 0;font-weight: 600;">{{ $t('baojingshuju') }}</div>
              <el-table :data="(yt.editObj && yt.editObj.realTimeAlerts) ? yt.editObj.realTimeAlerts : []" size="mini" border style="width: 100%">
                <el-table-column type="index" :label="$t('xuhao')" width="60"></el-table-column>
                <el-table-column :label="$t('baojingxinxi')">
                  <template #default="{ row }">
                    {{ row.i18n ? $t(row.i18n) : row.code }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('baojingshijian')" width="180">
                  <template #default="{ row }">
                    {{ row.alarmTime ? dayjs(row.alarmTime).format('YYYY-MM-DD HH:mm:ss') : '' }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="padding:20px 0px;">
              <div style="margin: 8px 0;font-weight: 600;">{{ $t('xiugaijilu') }}</div>
              <el-table :data="(yt.editObj && yt.editObj.editRecords) ? yt.editObj.editRecords : []" size="mini" border style="width: 100%">
                <el-table-column :label="$t('xiugaishijian')" width="180">
                  <template #default="{ row }">
                    {{ row.updateTime ? dayjs(row.updateTime).format('YYYY-MM-DD HH:mm:ss') : '' }}
                  </template>
                </el-table-column>
                <el-table-column prop="createByObject.nickname" :label="$t('xiugairen')" width="120"></el-table-column>
                <el-table-column :label="$t('xiugaiqian')" width="180">
                  <template #default="{ row }">
                    {{ getMouthName(row.beforeShootMouthId) }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('xiugaihou')" width="180">
                  <template #default="{ row }">
                    {{ getMouthName(row.afterShootMouthId) }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <div v-if="yt.editObj && (yt.editObj.currentStep == 2 || yt.editObj.currentStep == 3)" style="margin-bottom: 20px;">
            <el-tabs v-model="progressProcessTab">
              <el-tab-pane label="当前工艺" name="current">
                <div id="testMoldTableExport" style="padding:20px 40px 20px 40px;">
                  <div style="margin: 8px 0;font-weight: 600;">工艺数据</div>
                  <div class="testMoldTable" v-html="gy" v-watermark="watermarkText"></div>
                  <div v-if="ks" class="testMoldTable" v-html="ks" v-watermark="watermarkText"></div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="历史工艺" name="history">
                <div style="padding: 12px 0 16px;">
                  <el-select v-model="historyCraftId" :placeholder="$t('qingxuanze')" size="mini" style="width: 300px !important;" @change="changeHistoryCraftId">
                    <el-option v-for="item in historyCraftList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                  <el-button style="margin-left: 10px;" size="mini" type="primary" @click="exportHistoryExcel" :loading="exportExcelLoading">{{ $t('daochu') }}</el-button>
                  <el-button v-if="utils.checkPower('web_test_mold_work_order_deleteCurrentCraftParameter')" @click="deleteHistoryCraftParameter()" :disabled="historyCraftList.length === 0 || !historyCraftId" style="margin-left: 10px;" type="danger" size="mini">
                    {{ $t('shanchu') }}
                  </el-button>
                </div>
                <div id="testMoldTableExportHistory" style="padding:20px 40px 20px 40px;">
                  <div style="margin: 8px 0;font-weight: 600;">工艺数据</div>
                  <div class="testMoldTable" v-html="gyHistory" v-watermark="watermarkText"></div>
                  <div v-if="ksHistory" class="testMoldTable" v-html="ksHistory" v-watermark="watermarkText"></div>
                </div>
              </el-tab-pane>
              <el-tab-pane v-if="yt.editObj && yt.editObj.currentStep == 2" label="品质监控" name="qualityMonitor">
                <div style="padding: 12px 0 16px;">
                  <el-table :data="qualityMonitorData" size="mini" border style="width: 100%" max-height="400" v-loading="qualityMonitorLoading">
                    <el-table-column prop="name" label="参数名称" min-width="120" fixed></el-table-column>
                    <el-table-column prop="seq1" label="1" min-width="80" align="center"></el-table-column>
                    <el-table-column prop="seq2" label="2" min-width="80" align="center"></el-table-column>
                    <el-table-column prop="seq3" label="3" min-width="80" align="center"></el-table-column>
                    <el-table-column prop="seq4" label="4" min-width="80" align="center"></el-table-column>
                    <el-table-column prop="seq5" label="5" min-width="80" align="center"></el-table-column>
                    <el-table-column prop="seq6" label="6" min-width="80" align="center"></el-table-column>
                    <el-table-column prop="seq7" label="7" min-width="80" align="center"></el-table-column>
                    <el-table-column prop="seq8" label="8" min-width="80" align="center"></el-table-column>
                    <el-table-column prop="seq9" label="9" min-width="80" align="center"></el-table-column>
                    <el-table-column prop="seq10" label="10" min-width="80" align="center"></el-table-column>
                  </el-table>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div v-if="yt.editObj && yt.editObj.currentStep == 4" style="padding:40px 0;text-align:center;">
            <i class="el-icon-success" style="font-size:48px;color:#67C23A;"></i>
            <div style="margin-top:12px;font-weight:600;">{{ $t('shimowancheng') }}</div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button v-if="yt.editObj && yt.editObj.currentStep != 4 && !((yt.editObj.currentStep == 2 || yt.editObj.currentStep == 3) && progressProcessTab === 'history')" size="mini" @click="yt.isShowEditDialog = false">
            {{ $t('guanbi') }}
          </el-button>
          <template v-if="yt.editObj && yt.editObj.currentStep == 1">
            <yi_button size="mini" :onClick="getLatestProcessParams">{{ $t('huoquzuixingongyicanshu') }}</yi_button>
            <yi_button size="mini" :onClick="saveCurrentProcessParams">{{ $t('baocundangqiangongyicanshu') }}</yi_button>
          </template>
          <el-button v-if="yt.editObj && yt.editObj.currentStep == 1" :loading="yt.editObj.loading" size="mini" @click="nextStep()" type="primary">
            {{ $t('tijiaoxiayibu') }}
          </el-button>
          <template v-if="yt.editObj && (yt.editObj.currentStep == 2 || yt.editObj.currentStep == 3) && progressProcessTab === 'history'">
            <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('guanbi') }}</el-button>
          </template>
          <template v-else-if="yt.editObj && (yt.editObj.currentStep == 2 || yt.editObj.currentStep == 3)">
            <yi_button size="mini" :onClick="previousStep">{{ $t('shangyibu') }}</yi_button>
            <yi_button v-if="progressProcessTab !== 'qualityMonitor'" size="mini" :onClick="exportExcel" :loading="exportExcelLoading">{{ $t('daochu') }}</yi_button>
            <yi_button size="mini" :onClick="getLatestProcessParams">{{ $t('huoquzuixingongyicanshu') }}</yi_button>
            <yi_button size="mini" :onClick="progressProcessTab === 'qualityMonitor' ? saveQualityMonitorParams : saveCurrentProcessParams">{{ $t('baocundangqiangongyicanshu') }}</yi_button>
            <yi_button size="mini" :onClick="nextStep" type="primary">{{ $t('xiayibu') }}</yi_button>
          </template>
          <template v-if="yt.editObj && yt.editObj.currentStep == 4">
            <yi_button size="mini" :onClick="closeDialog">{{ $t('fanhuiliebiao') }}</yi_button>
            <yi_button size="mini" type="primary" :onClick="viewOrder">{{ $t('chakangongdan') }}</yi_button>
          </template>
        </span>
      </template>
    </el-dialog>
    <!-- 保存当前工艺参数弹框 -->
    <el-dialog :show-close="true" :title="$t('baocundangqiangongyicanshu')" :visible.sync="isShowSaveProcessDialog" :width="'400px'" :close-on-click-modal="false" append-to-body="append-to-body">
      <el-form ref="saveProcessForm" :model="saveProcessForm" size="mini" label-width="80px">
        <el-form-item :label="$t('mingcheng')" required>
          <el-input v-model="saveProcessForm.name" :placeholder="$t('qingshuru')"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowSaveProcessDialog = false">{{ $t('quxiao') }}</el-button>
        <yi_button size="mini" type="primary" :onClick="confirmSaveCurrentProcessParams">{{ $t('queding') }}</yi_button>
      </span>
    </el-dialog>
    <!-- 修改射嘴弹框 -->
    <el-dialog :show-close="true" :title="$t('xiugaishezuimingcheng')" :visible.sync="isShowUpdateShootingMouthDialog" :width="'400px'" :close-on-click-modal="false" append-to-body="append-to-body">
      <el-form :model="updateShootingMouthForm" size="mini" label-width="100px">
        <el-form-item :label="$t('shezuimingcheng')" required>
          <yi_data_select :type="'mouth'" :ids.sync="updateShootingMouthForm.afterShootMouthId"></yi_data_select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowUpdateShootingMouthDialog = false">{{ $t('quxiao') }}</el-button>
        <el-button :loading="updateShootingMouthLoading" size="mini" @click="confirmUpdateShootingMouth()" type="primary">
          {{ $t('queding') }}
        </el-button>
      </span>
    </el-dialog>
    <!-- 修改设备弹框 -->
    <el-dialog :show-close="true" :title="$t('xiugai') + $t('shebeimingcheng')" :visible.sync="isShowUpdateEquipmentDialog" :width="'400px'" :close-on-click-modal="false" append-to-body="append-to-body">
      <el-form :model="updateEquipmentForm" size="mini" label-width="100px">
        <el-form-item :label="$t('shebeimingcheng')" required>
          <yi_data_select :type="'equipment'" :ids.sync="updateEquipmentForm.equipmentId"></yi_data_select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowUpdateEquipmentDialog = false">{{ $t('quxiao') }}</el-button>
        <el-button :loading="updateEquipmentLoading" size="mini" @click="confirmUpdateEquipment()" type="primary">
          {{ $t('queding') }}
        </el-button>
      </span>
    </el-dialog>
    <trial-mould-wo-attachment-dialog
      :visible.sync="attachmentDialog.visible"
      :row="attachmentDialog.row"
      @closed="onTrialWoAttachmentClosed"
    />
  </div>
</template>

<script type="text/javascript">
import Yi_upload from '@/common/yi_upload/yi_upload.vue';
import Yi_button from '@/common/yi_button/yi_button.vue';
import TrialMouldWoAttachmentDialog from './trial_mould_wo_attachment_dialog.vue';
import html2canvas from 'html2canvas';
import dayjs from 'dayjs';

export default {
  name: 'web_test_mold_work_order_list',
  components: { Yi_button, Yi_upload, TrialMouldWoAttachmentDialog },
  data() {
    return {
      exportExcelLoading: false,
      watermarkText: this.store.state.organizations[0].name + '-' + this.store.state.user.nickname,
      gyHtml: "",
      ksHtml: "",
      childDevices: [],
      deviceValueMap: {},
      activeTab: '0', // 标签页索引
      // 试模进度弹窗：步骤2/3 当前工艺 / 历史工艺
      progressProcessTab: 'current',
      historyCraftList: [],
      historyCraftId: null,
      historyDeviceValueMap: {},
      craftParameterList: [],
      currentCraftParameterId: null,
      // 保存工艺参数弹框
      isShowSaveProcessDialog: false,
      saveProcessForm: { name: '' },
      createTimeStart: 0,
      createTimeEnd: 0,
      insertLoading: false,
      isShowUpdateShootingMouthDialog: false,
      updateShootingMouthForm: {
        afterShootMouthId: null
      },
      updateShootingMouthLoading: false,
      isShowUpdateEquipmentDialog: false,
      updateEquipmentForm: {
        equipmentId: null
      },
      updateEquipmentLoading: false,
      attachmentDialog: {
        visible: false,
        row: null
      },
      // 查看弹窗：空射调试阶段最近一次保存的工艺参数（非实时）
      viewStepOneDeviceValueMap: {},
      // 品质监控
      qualityMonitorData: [],
      qualityMonitorLoading: false,
      saveQualityMonitorLoading: false,
      // 查看弹窗：试模工艺子tab
      viewCraftSubTab: 'history',
      viewQualityMonitorData: [],
      viewQualityMonitorLoading: false,
      // 表单数据绑定到 yt.editObj
      columns: [
        {
          label: 'danjuzhuangtai',
          type: 'dictionary',
          key: 'TRIAL_MOULD_WO_STATUS',
          prop: 'status'
        },
        {
          label: 'shimojihuadanhao',
          prop: 'planNo'
        },
        {
          label: 'shezuibianma',
          prop: 'shootingMouth.code'
        },
        {
          label: 'shezuimingcheng',
          prop: 'shootingMouth.name'
        },
        {
          label: 'wuliaobianma',
          prop: 'material.code'
        },
        {
          label: 'wuliaomingcheng',
          prop: 'material.name'
        },
        {
          label: 'shebeibianma',
          prop: 'equipment.sn'
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name'
        },
        {
          label: 'mojubianma',
          prop: 'mould.code'
        },
        {
          label: 'mojumingcheng',
          prop: 'mould.name'
        },
        {
          label: 'lilungongyika',
          type: 'slot',
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 200,
          fixed: 'right'
        },

      ]
    };
  },
  directives: {
    watermark: {
      inserted(el, binding) {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = 300;
        canvas.height = 200;
        ctx.font = '14px Arial';
        ctx.fillStyle = 'rgba(100, 100, 100, 0.3)'; // 水印颜色和透明度
        ctx.rotate((-20 * Math.PI) / 180); // 旋转角度
        let text = binding.value;
        if (text.length > 15) {
          let splitText = [];
          for (let i = 0; i < text.length; i += 15) {
            splitText.push(text.slice(i, i + 15));
          }
          text = splitText.join('\n');
        }
        // 保存初始的 y 坐标
        let y = 100;
        // 计算行高
        let lineHeight = parseInt(ctx.font, 10);
        // 增加行间距，这里设置为 5 像素
        let lineSpacing = 5;
        // 按行绘制文本并添加行间距
        text.split('\n').forEach((line, index) => {
          ctx.fillText(line, 50, y + index * (lineHeight + lineSpacing));
        });
        const imgData = canvas.toDataURL('image/png');
        el.style.backgroundImage = `url(${imgData})`;
        el.style.backgroundRepeat = 'repeat';
      }
    }
  },
  computed: {
    gy() {
      if (!this.gyHtml) return '';
      let str = this.base64.decode(this.gyHtml);
      let reg1 = /\[[^\]]*\]/g;
      str.match(reg1) && str.match(reg1).map((code) => {
        let c = code.replace("[", "").replace("]", "");
        str = str.replace(code, this.$t(c));
      });
      let reg2 = /\{[^\}]*\}/g;
      str.match(reg2) && str.match(reg2).map((code) => {
        let c = code.replace("{", "").replace("}", "");
        let value = this.deviceValueMap[this.yt.editObj.equipmentId] && this.deviceValueMap[this.yt.editObj.equipmentId][c];
        if (value == null) {
          str = str.replace(code, "");
        } else {
          str = str.replace(code, value);
        }
      });
      //辅机
      if (this.childDevices.length > 0) {
        for (let deviceObj of this.childDevices) {
          if (!deviceObj.tab.gy) {
            continue;
          }
          let childStr = this.base64.decode(deviceObj.tab.gy);
          childStr.match(reg1) && childStr.match(reg1).map((code) => {
            let c = code.replace("[", "").replace("]", "");
            childStr = childStr.replace(code, this.$t(c));
          });
          childStr.match(reg2) && childStr.match(reg2).map((code) => {
            let c = code.replace("{", "").replace("}", "");
            let chileValue = this.deviceValueMap[deviceObj.device.id] && this.deviceValueMap[deviceObj.device.id][c];
            if (chileValue == null) {
              childStr = childStr.replace(code, "");
            } else {
              childStr = childStr.replace(code, chileValue);
            }
          });
          str += childStr;
        }
      }
      return str;
    },
    ks() {
      return this.buildKsFromMap(this.deviceValueMap);
    },
    ksViewStepOne() {
      return this.buildKsFromMap(this.viewStepOneDeviceValueMap);
    },
    gyHistory() {
      if (!this.gyHtml || !this.yt.editObj || !this.yt.editObj.equipmentId) return '';
      let str = this.base64.decode(this.gyHtml);
      let reg1 = /\[[^\]]*\]/g;
      str.match(reg1) &&
        str.match(reg1).map(code => {
          let c = code.replace('[', '').replace(']', '');
          str = str.replace(code, this.$t(c));
        });
      let reg2 = /\{[^\}]*\}/g;
      str.match(reg2) &&
        str.match(reg2).map(code => {
          let c = code.replace('{', '').replace('}', '');
          let value =
            this.historyDeviceValueMap[this.yt.editObj.equipmentId] && this.historyDeviceValueMap[this.yt.editObj.equipmentId][c];
          if (value == null) {
            str = str.replace(code, '');
          } else {
            str = str.replace(code, value);
          }
        });
      if (this.childDevices.length > 0) {
        for (let deviceObj of this.childDevices) {
          if (!deviceObj.tab.gy) {
            continue;
          }
          let childStr = this.base64.decode(deviceObj.tab.gy);
          childStr.match(reg1) &&
            childStr.match(reg1).map(code => {
              let c = code.replace('[', '').replace(']', '');
              childStr = childStr.replace(code, this.$t(c));
            });
          childStr.match(reg2) &&
            childStr.match(reg2).map(code => {
              let c = code.replace('{', '').replace('}', '');
              let chileValue = this.historyDeviceValueMap[deviceObj.device.id] && this.historyDeviceValueMap[deviceObj.device.id][c];
              if (chileValue == null) {
                childStr = childStr.replace(code, '');
              } else {
                childStr = childStr.replace(code, chileValue);
              }
            });
          str += childStr;
        }
      }
      return str;
    },
    ksHistory() {
      if (!this.ksHtml || !this.yt.editObj || !this.yt.editObj.equipmentId) return '';
      let str = this.base64.decode(this.ksHtml);
      let reg1 = /\[[^\]]*\]/g;
      str.match(reg1) &&
        str.match(reg1).map(code => {
          let c = code.replace('[', '').replace(']', '');
          str = str.replace(code, this.$t(c));
        });
      let reg2 = /\{[^\}]*\}/g;
      str.match(reg2) &&
        str.match(reg2).map(code => {
          let c = code.replace('{', '').replace('}', '');
          let value =
            this.historyDeviceValueMap[this.yt.editObj.equipmentId] && this.historyDeviceValueMap[this.yt.editObj.equipmentId][c];
          if (value == null) {
            str = str.replace(code, '');
          } else {
            str = str.replace(code, value);
          }
        });
      if (this.childDevices.length > 0) {
        for (let deviceObj of this.childDevices) {
          if (!deviceObj.tab.ks) {
            continue;
          }
          let childStr = this.base64.decode(deviceObj.tab.ks);
          childStr.match(reg1) &&
            childStr.match(reg1).map(code => {
              let c = code.replace('[', '').replace(']', '');
              childStr = childStr.replace(code, this.$t(c));
            });
          childStr.match(reg2) &&
            childStr.match(reg2).map(code => {
              let c = code.replace('{', '').replace('}', '');
              let chileValue = this.historyDeviceValueMap[deviceObj.device.id] && this.historyDeviceValueMap[deviceObj.device.id][c];
              if (chileValue == null) {
                childStr = childStr.replace(code, '');
              } else {
                childStr = childStr.replace(code, chileValue);
              }
            });
          str += childStr;
        }
      }
      return str;
    }
  },
  watch: {
    activeTab(newVal) {
      // 当切换到试模工艺（索引1，步骤2）或分段采集（索引2，步骤3）时，请求数据
      if (newVal === '1' || newVal === '2') {
        const currentStep = newVal === '1' ? '2' : '3';
        // 如果模板数据不存在，先获取模板
        if (!this.gyHtml && this.yt.editObj && this.yt.editObj.equipmentId) {
          this.getTemplateData().then(() => {
            this.getCraftParameterList(currentStep);
          });
        } else {
          this.getCraftParameterList(currentStep);
        }
      }
    },
    progressProcessTab(val) {
      if (
        val === 'history' &&
        this.yt.editObj &&
        this.yt.editObj.action === 'shimojindu' &&
        (this.yt.editObj.currentStep == 2 || this.yt.editObj.currentStep == 3)
      ) {
        this.loadHistoryCraftList();
      }
      // 切换到品质监控 tab 时加载数据
      if (val === 'qualityMonitor') {
        this.getQualityMonitorData();
      }
    },
    viewCraftSubTab(val) {
      // 查看弹窗：切换到品质监控子tab时加载数据
      if (val === 'qualityMonitor') {
        this.loadViewQualityMonitorData();
      }
    }
  },
  created() {
    setTimeout(() => {
      this.yt.conditions.orderBy = 'id desc';
      this.yt.get(1);

    }, 300);
  },

  methods: {
    openAttachmentDialog(row) {
      this.attachmentDialog.row = row;
      this.attachmentDialog.visible = true;
    },
    onTrialWoAttachmentClosed({ row, attachFileIds }) {
      const dialogRow = this.attachmentDialog.row;
      if (dialogRow && row && dialogRow === row && Number(row.status) !== 4) {
        const next = Array.isArray(attachFileIds)
          ? attachFileIds.filter(id => id != null && id !== '')
          : attachFileIds != null && attachFileIds !== ''
            ? [attachFileIds]
            : [];
        this.$set(row, 'attachFileIds', next.length ? next : null);
      }
      this.attachmentDialog.row = null;
    },
    // 根据设备值映射渲染空射(ks)表格 HTML（主机 + 辅机）
    buildKsFromMap(valueMap) {
      if (!this.ksHtml || !this.yt.editObj || !this.yt.editObj.equipmentId) return '';
      let str = this.base64.decode(this.ksHtml);
      let reg1 = /\[[^\]]*\]/g;
      str.match(reg1) && str.match(reg1).map((code) => {
        let c = code.replace('[', '').replace(']', '');
        str = str.replace(code, this.$t(c));
      });
      let reg2 = /\{[^\}]*\}/g;
      str.match(reg2) && str.match(reg2).map((code) => {
        let c = code.replace('{', '').replace('}', '');
        let value = valueMap[this.yt.editObj.equipmentId] && valueMap[this.yt.editObj.equipmentId][c];
        if (value == null) {
          str = str.replace(code, '');
        } else {
          str = str.replace(code, value);
        }
      });
      if (this.childDevices.length > 0) {
        for (let deviceObj of this.childDevices) {
          if (!deviceObj.tab.ks) {
            continue;
          }
          let childStr = this.base64.decode(deviceObj.tab.ks);
          childStr.match(reg1) && childStr.match(reg1).map((code) => {
            let c = code.replace('[', '').replace(']', '');
            childStr = childStr.replace(code, this.$t(c));
          });
          childStr.match(reg2) && childStr.match(reg2).map((code) => {
            let c = code.replace('{', '').replace('}', '');
            let chileValue = valueMap[deviceObj.device.id] && valueMap[deviceObj.device.id][c];
            if (chileValue == null) {
              childStr = childStr.replace(code, '');
            } else {
              childStr = childStr.replace(code, chileValue);
            }
          });
          str += childStr;
        }
      }
      return str;
    },
    // 查看弹窗：加载空射调试阶段最近一次保存的工艺参数
    loadViewStepOneCraftParameters() {
      if (!this.yt.editObj || !this.yt.editObj.id) return;
      this.viewStepOneDeviceValueMap = {};
      this.http
        .get('/web/trial/mould/wo/craft/parameter/list', {
          params: { trialMouldWoId: this.yt.editObj.id, currentStep: '1' }
        })
        .then(res => {
          const dataList = Array.isArray(res.data) ? res.data : [];
          if (dataList.length === 0) {
            return;
          }
          const sorted = [...dataList].sort((a, b) => {
            const timeA = a.updateTime || a.createTime || '';
            const timeB = b.updateTime || b.createTime || '';
            if (timeA !== timeB) {
              return String(timeB).localeCompare(String(timeA));
            }
            return (Number(b.id) || 0) - (Number(a.id) || 0);
          });
          const latest = sorted[0];
          if (!latest) return;
          try {
            this.viewStepOneDeviceValueMap = JSON.parse(latest.value) || {};
          } catch (e) {
            this.viewStepOneDeviceValueMap = {};
          }
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        });
    },
    // 查看弹窗：加载品质监控参数（currentStep=2-1）
    loadViewQualityMonitorData() {
      if (!this.yt.editObj || !this.yt.editObj.id) return;
      this.viewQualityMonitorData = [];
      this.viewQualityMonitorLoading = true;
      this.http
        .get('/web/trial/mould/wo/craft/parameter/list', {
          params: { trialMouldWoId: this.yt.editObj.id, currentStep: '2-1' }
        })
        .then(res => {
          const dataList = Array.isArray(res.data) ? res.data : [];
          if (dataList.length === 0) {
            return;
          }
          const sorted = [...dataList].sort((a, b) => {
            const timeA = a.updateTime || a.createTime || '';
            const timeB = b.updateTime || b.createTime || '';
            if (timeA !== timeB) {
              return String(timeB).localeCompare(String(timeA));
            }
            return (Number(b.id) || 0) - (Number(a.id) || 0);
          });
          const latest = sorted[0];
          if (!latest) return;
          try {
            this.viewQualityMonitorData = JSON.parse(latest.value) || [];
          } catch (e) {
            this.viewQualityMonitorData = [];
          }
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.viewQualityMonitorLoading = false;
        });
    },
    // 删除当前工艺模板
    deleteCurrentCraftParameter() {
      if (!this.currentCraftParameterId) {
        this.$message.warning(this.$t('qingxuanze'));
        return;
      }
      this.$confirm(this.$t('shifouquerenshanchudangqiangongyimoban'), this.$t('tishi'), {
        confirmButtonText: this.$t('shanchu'),
        cancelButtonText: this.$t('quxiao'),
        type: 'error'
      }).then(() => {
        this.http
          .post('/web/trial/mould/wo/craft/parameter/delete', { id: this.currentCraftParameterId })
          .then(res => {
            this.$message.success(this.$t(res.msg));
            const currentStep = this.activeTab === '1' ? '2' : '3';
            this.getCraftParameterList(currentStep);
          })
          .catch(err => {
            this.$message.error(this.$t(err));
          });
      }).catch(() => {
      });
    },
    changeCraftId(id) {
      let item = this.craftParameterList.filter(obj => obj.id == id)[0];
      //如果当前工艺参数为空，则设置为第一个
      this.currentCraftParameterId = item.id;
      this.deviceValueMap = JSON.parse(item.value);
    },
    // 试模进度：历史工艺列表（不影响当前 deviceValueMap）
    loadHistoryCraftList() {
      if (!this.yt.editObj || !this.yt.editObj.id) return;
      const step = String(this.yt.editObj.currentStep);
      this.historyCraftList = [];
      this.historyCraftId = null;
      this.historyDeviceValueMap = {};
      this.http
        .get('/web/trial/mould/wo/craft/parameter/list', {
          params: { trialMouldWoId: this.yt.editObj.id, currentStep: step }
        })
        .then(res => {
          const dataList = Array.isArray(res.data) ? res.data : [];
          this.historyCraftList = dataList;
          if (dataList.length > 0) {
            this.historyCraftId = dataList[0].id;
            try {
              this.historyDeviceValueMap = JSON.parse(dataList[0].value) || {};
            } catch (e) {
              this.historyDeviceValueMap = {};
            }
          }
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        });
    },
    changeHistoryCraftId(id) {
      const item = this.historyCraftList.filter(obj => obj.id == id)[0];
      if (!item) return;
      this.historyCraftId = item.id;
      try {
        this.historyDeviceValueMap = JSON.parse(item.value) || {};
      } catch (e) {
        this.historyDeviceValueMap = {};
      }
    },
    deleteHistoryCraftParameter() {
      if (!this.historyCraftId) {
        this.$message.warning(this.$t('qingxuanze'));
        return;
      }
      this.$confirm(this.$t('shifouquerenshanchudangqiangongyimoban'), this.$t('tishi'), {
        confirmButtonText: this.$t('shanchu'),
        cancelButtonText: this.$t('quxiao'),
        type: 'error'
      })
        .then(() => {
          this.http
            .post('/web/trial/mould/wo/craft/parameter/delete', { id: this.historyCraftId })
            .then(res => {
              this.$message.success(this.$t(res.msg));
              this.loadHistoryCraftList();
            })
            .catch(err => {
              this.$message.error(this.$t(err));
            });
        })
        .catch(() => { });
    },
    // 导出历史工艺参数到Excel
    exportHistoryExcel() {
      let value = this.historyDeviceValueMap[this.yt.editObj.equipmentId] && this.historyDeviceValueMap[this.yt.editObj.equipmentId];
      if (!value) {
        this.$message.warning(this.$t('meiyougongyicanshu'));
        return;
      }
      this.exportExcelLoading = true;
      const params = {
        value: JSON.stringify(value),
        trialMouldWoId: this.yt.editObj.id
      };
      this.http.post('/web/trial/mould/wo/craft/parameter/exportExcel', params)
        .then(res => {
          if (res.data) {
            const a = document.createElement('a');
            a.href = res.data;
            a.download = this.$t('gongyicanshu') + dayjs().format('YYYYMMDDHHmmss') + '.xlsx';
            a.click();
          }
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        }).finally(() => {
          this.exportExcelLoading = false;
        });
    },
    exportHistoryProcess() {
      const element = document.getElementById('testMoldTableExportHistory');
      if (!element) {
        this.$message.warning(this.$t('qingxuanze'));
        return;
      }
      html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff'
      })
        .then(canvas => {
          const dataURL = canvas.toDataURL('image/png');
          if (dataURL !== '') {
            const a = document.createElement('a');
            a.download = this.$t('gongyicanshu') + '_history.png';
            a.href = dataURL;
            a.click();
          }
        })
        .catch(() => {
          this.$message.error(this.$t('daochushibai'));
        });
    },
    // exportExcel() {
    //   let params = this.yt.conditions;
    //   // params.materialId = this.yt.conditions.materialIdList;
    //   // params.equipmentId = this.yt.conditions.equipmentIdList;
    //   // params.status = this.yt.conditions.statusList;
    //   // delete params.materialIdList;
    //   // delete params.equipmentIdList;
    //   // delete params.statusList;
    //   // delete params.orderBy;
    //   return this.http
    //     .get('/web/report/export/aps_scheduling_log_export', { params })
    //     .then(res => {
    //       this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
    //     })
    //     .catch(error => {
    //       this.$message.error(this.$t(error));
    //     });
    // },

    // 获取实时报警
    getRealTimeAlerts() {

      this.http
        .get('/web/trial/mould/wo/alarm/realTime', { params: { equipmentId: this.yt.editObj.equipmentId, } })
        .then(res => {
          this.$set(this.yt.editObj, 'realTimeAlerts', Array.isArray(res.data) ? res.data : []);
        })
        .catch(() => {
          this.$set(this.yt.editObj, 'realTimeAlerts', []);
        });
    },
    // 获取修改记录
    getEditRecords() {
      if (!this.yt || !this.yt.editObj || !this.yt.editObj.id) {
        if (this.yt && this.yt.editObj) this.yt.editObj.editRecords = [];
        return;
      }
      this.http
        .get('/web/trial/mould/wo/shoot/mouth/edit/record/page', { params: { trialMouldWoId: this.yt.editObj.id, pageNum: 1, pageSize: 100 } })
        .then(res => {
          this.$set(this.yt.editObj, 'editRecords', Array.isArray(res.data && res.data.rows) ? res.data.rows : []);
        })
        .catch(() => {
          this.$set(this.yt.editObj, 'editRecords', []);
        });
    },
    // 提交下一步
    nextStep() {

      const params = {
        id: this.yt.editObj.id,
        currentStep: this.yt.editObj.currentStep
      };
      this.http
        .post('/web/trial/mould/wo/next/step', params)
        .then(res => {
          // 刷新当前弹框的数据
          this.refreshProgressDialog();
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        });
    },
    // 上一步
    previousStep() {
      const params = {
        id: this.yt.editObj.id,
        currentStep: this.yt.editObj.currentStep
      };
      this.http
        .post('/web/trial/mould/wo/previous/step', params)
        .then(res => {
          // 刷新当前弹框的数据
          this.refreshProgressDialog();
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        });
    },
    // 导出工艺参数到Excel
    exportExcel() {
      let value = this.deviceValueMap[this.yt.editObj.equipmentId] && this.deviceValueMap[this.yt.editObj.equipmentId];
      if (!value) {
        this.$message.warning(this.$t('meiyougongyicanshu'));
        return;
      }
      this.exportExcelLoading = true;
      const params = {
        value: JSON.stringify(value),
        trialMouldWoId: this.yt.editObj.id
      };
      this.http.post('/web/trial/mould/wo/craft/parameter/exportExcel', params)
        .then(res => {
          if (res.data) {
            const a = document.createElement('a');
            a.href = res.data;
            a.download = this.$t('gongyicanshu') + dayjs().format('YYYYMMDDHHmmss') + '.xlsx';
            a.click();
          }
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        }).finally(() => {
          this.exportExcelLoading = false;
        });
    },
    // 导出
    exportData() {
      const element = document.getElementById('testMoldTableExport');
      if (!element) {
        this.$message.warning(this.$t('qingxuanze'));
        return;
      }
      html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff'
      }).then(canvas => {
        const dataURL = canvas.toDataURL('image/png');
        if (dataURL !== '') {
          const a = document.createElement('a');
          a.download = this.$t('gongyicanshu') + '.png';
          a.href = dataURL;
          a.click();
        }
      }).catch(err => {
        this.$message.error(this.$t('daochushibai'));
      });
    },
    // 新增保存
    createWo() {
      const result = this.yt.req('POST', '/web/trial/mould/wo/create');
      if (result && typeof result.then === 'function') {
        result.then(() => {
          this.$message.success(this.$t('caozuochenggong'));
        }).catch(err => {
          this.$message.error(this.$t(err));
        });
      }
    },
    // 编辑保存
    updateWo() {
      const result = this.yt.req('POST', '/web/trial/mould/wo/update');
      if (result && typeof result.then === 'function') {
        result.then(() => {
          this.$message.success(this.$t('caozuochenggong'));
        }).catch(err => {
          this.$message.error(this.$t(err));
        });
      }
    },
    // 关闭弹窗（返回列表）
    closeDialog() {
      this.yt.isShowEditDialog = false;
    },
    // 查看工单
    viewOrder() {
      this.yt.get();
      this.activeTab = '0';
      this.yt.showEditDialog('chakan', this.yt.editObj, '80%');
      this.refreshProgressDialog()
    },
    // 获取最新工艺参数
    async getLatestProcessParams() {

      try {
        // 先获取设备工艺模板
        const templateRes = await this.http.get('/web/config/craft/template/monitor/tab', {
          params: { equipmentId: this.yt.editObj.equipmentId }
        });
        this.gyHtml = templateRes.data.tab.gy;
        this.ksHtml = (templateRes.data.tab && templateRes.data.tab.ks) ? templateRes.data.tab.ks : '';
        this.childDevices = templateRes.data.devices;

        // 然后获取所有工艺点的实时数据
        let valueMap = {}
        //获取辅机数据
        if (this.childDevices.length > 0) {
          let child = await this.http.get('/web/equipment/getSingleAuxiliaryMonitorData', {
            params: { equipmentId: this.yt.editObj.equipmentId }
          });
          valueMap = child.data;
        }
        //获取主机数据
        const realTimeRes = await this.http.get('/web/equipment/getSingleMonitorData', {
          params: { equipmentId: this.yt.editObj.equipmentId }
        });
        valueMap[this.yt.editObj.equipmentId] = realTimeRes.data
        this.deviceValueMap = valueMap;

        this.$message.success(this.$t('caozuochenggong'));

        // 可以在这里处理返回的数据，比如保存到 yt.editObj 中
        // this.$set(this.yt.editObj, 'processTemplate', templateRes.data);
        // this.$set(this.yt.editObj, 'processRealTimeData', realTimeRes.data);
      } catch (err) {
        this.$message.error(this.$t(err));
      }
    },
    // 获取模板数据
    async getTemplateData() {
      if (!this.yt.editObj || !this.yt.editObj.equipmentId) {
        return Promise.resolve();
      }
      try {
        const templateRes = await this.http.get('/web/config/craft/template/monitor/tab', {
          params: { equipmentId: this.yt.editObj.equipmentId }
        });
        this.gyHtml = templateRes.data.tab.gy;
        this.ksHtml = (templateRes.data.tab && templateRes.data.tab.ks) ? templateRes.data.tab.ks : '';
        this.childDevices = templateRes.data.devices;
        return Promise.resolve();
      } catch (err) {
        console.error('获取模板数据失败', err);
        return Promise.resolve();
      }
    },
    // 获取工艺参数列表
    getCraftParameterList(currentStep) {
      this.craftParameterList = []
      this.currentCraftParameterId = null;

      this.http
        .get('/web/trial/mould/wo/craft/parameter/list', {
          params: {
            trialMouldWoId: this.yt.editObj.id,
            currentStep: currentStep
          }
        })
        .then(res => {
          const dataList = Array.isArray(res.data) ? res.data : [];
          this.craftParameterList = dataList;
          //如果当前工艺参数为空，则设置为第一个
          if (this.craftParameterList.length > 0) {
            this.currentCraftParameterId = dataList[0].id;
            this.deviceValueMap = JSON.parse(dataList[0].value);
          } else {
            this.currentCraftParameterId = null;
            this.deviceValueMap = {};
          }
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        });
    },
    // 保存当前工艺参数：步骤1 直接用默认名称提交；步骤2/3 先确认再打开命名弹框
    saveCurrentProcessParams() {
      if (this.yt.editObj && Number(this.yt.editObj.currentStep) === 1) {
        const defaultName = this.$t('baocundangqiangongyicanshu') + '_' + Date.now();
        this.postSaveCraftParameter(defaultName);
        return;
      }
      this.$confirm(this.$t('shifouyihuoquzuixindegongyicanshu'), this.$t('tishi'), {
        confirmButtonText: this.$t('jixu'),
        cancelButtonText: this.$t('quxiao'),
        type: 'warning'
      }).then(() => {
        this.saveProcessForm.name = '';
        this.isShowSaveProcessDialog = true;
      }).catch(() => {
      });
    },
    postSaveCraftParameter(name) {
      if (!this.yt.editObj || !this.yt.editObj.id) return;
      const params = {
        trialMouldWoId: this.yt.editObj.id,
        name,
        currentStep: this.yt.editObj.currentStep,
        value: JSON.stringify(this.deviceValueMap)
      };
      this.http
        .post('/web/trial/mould/wo/craft/parameter/create', params)
        .then(() => {
          this.isShowSaveProcessDialog = false;
          this.$message.success(this.$t('caozuochenggong'));
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        });
    },
    // 确认保存当前工艺参数（步骤2/3 命名弹框）
    confirmSaveCurrentProcessParams() {
      const name = (this.saveProcessForm.name || '').trim();
      if (!name) {
        this.$message.warning(this.$t('qingshuru') + this.$t('mingcheng'));
        return;
      }
      this.postSaveCraftParameter(name);
    },

    // 刷新试模进度弹框数据
    refreshProgressDialog() {
      if (this.yt.editObj && this.yt.editObj.id) {
        this.http.get('/web/trial/mould/wo/page', { params: { id: this.yt.editObj.id } }).then(res => {
          Object.assign(this.yt.editObj, res.data.rows[0]);
          this.progressProcessTab = 'current';
          this.getRealTimeAlerts();
          this.getEditRecords();
          const action = this.yt.editObj.action;
          if (action === 'chakan') {
            this.getTemplateData().then(() => {
              this.loadViewStepOneCraftParameters();
            });
            this.loadViewQualityMonitorData();
          } else if (action === 'shimojindu') {
            if (this.yt.editObj.currentStep == 2 || this.yt.editObj.currentStep == 3) {
              this.getCraftParameterList(String(this.yt.editObj.currentStep));
            }
            this.getLatestProcessParams();
          }
        });
      }
    },
    // 处理弹窗关闭事件
    handleDialogClose() {
      // 如果是试模进度弹窗，关闭时刷新列表
      if (this.yt.editObj && this.yt.editObj.action === 'shimojindu') {
        this.yt.get();
      }
    },
    // 修改射嘴
    updateShootingMouth() {
      if (this.yt.editObj.currentStep != 1) {
        this.$message.warning(this.$t('fanhuikongshetiaoshijieduan'));
        return;
      }
      this.updateShootingMouthForm.afterShootMouthId = this.yt.editObj.shootingMouthId;
      this.isShowUpdateShootingMouthDialog = true;
    },
    // 确认修改射嘴
    confirmUpdateShootingMouth() {
      if (!this.updateShootingMouthForm.afterShootMouthId) {
        this.$message.error(this.$t('qingxuanzeshezuimingcheng'));
        return;
      }
      this.updateShootingMouthLoading = true;
      const params = {
        trialMouldWoId: this.yt.editObj.id,
        afterShootMouthId: this.updateShootingMouthForm.afterShootMouthId
      };
      this.http
        .post('/web/trial/mould/wo/shoot/mouth/edit/record/create', params)
        .then(res => {
          this.isShowUpdateShootingMouthDialog = false;
          this.updateShootingMouthForm.afterShootMouthId = null;
          // 刷新数据
          this.yt.get(1);
          // 刷新当前弹框的数据
          if (this.yt.editObj && this.yt.editObj.id) {
            this.http.get('/web/trial/mould/wo/page', { params: { id: this.yt.editObj.id } }).then(res => {
              Object.assign(this.yt.editObj, res.data.rows[0]);
              this.getEditRecords();
            });
          }
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.updateShootingMouthLoading = false;
        });
    },
    // 修改设备（空射调试步骤）
    updateEquipment() {
      if (this.yt.editObj.currentStep != 1) {
        this.$message.warning(this.$t('fanhuikongshetiaoshijieduan'));
        return;
      }
      this.updateEquipmentForm.equipmentId = this.yt.editObj.equipmentId;
      this.isShowUpdateEquipmentDialog = true;
    },
    // 确认修改设备
    confirmUpdateEquipment() {
      if (!this.updateEquipmentForm.equipmentId) {
        this.$message.error(this.$t('qingxuanzeshebei'));
        return;
      }
      this.updateEquipmentLoading = true;
      const params = {
        id: this.yt.editObj.id,
        equipmentId: this.updateEquipmentForm.equipmentId
      };
      this.http
        .post('/web/trial/mould/wo/updateEquipment', params)
        .then(() => {
          this.isShowUpdateEquipmentDialog = false;
          this.updateEquipmentForm.equipmentId = null;
          this.yt.get();
          if (this.yt.editObj && this.yt.editObj.id) {
            this.http.get('/web/trial/mould/wo/page', { params: { id: this.yt.editObj.id } }).then(res => {
              Object.assign(this.yt.editObj, res.data.rows[0]);
              this.getRealTimeAlerts();
            });
          }
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.updateEquipmentLoading = false;
        });
    },
    // 从 store 获取射嘴名称
    getMouthName(mouthId) {
      if (!mouthId || !this.store.state.mouths || this.store.state.mouths.length === 0) {
        return '';
      }
      const mouth = this.store.state.mouths.find(item => item.id === mouthId);
      return mouth ? (mouth.name || mouth.code || '') : '';
    },
    // 获取品质监控数据
    getQualityMonitorData() {
      if (!this.yt.editObj || !this.yt.editObj.equipmentId) {
        this.qualityMonitorData = [];
        return;
      }
      this.qualityMonitorLoading = true;
      this.http
        .get('/web/trial/mould/wo/craft/parameter/queryCodeValues', {
          params: { equipmentId: this.yt.editObj.equipmentId }
        })
        .then(res => {
          this.qualityMonitorData = Array.isArray(res.data) ? res.data : [];
        })
        .catch(err => {
          this.qualityMonitorData = [];
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.qualityMonitorLoading = false;
        });
    },
    // 保存品质监控参数
    saveQualityMonitorParams() {
      if (!this.yt.editObj || !this.yt.editObj.id) {
        return;
      }
      if (!this.qualityMonitorData || this.qualityMonitorData.length === 0) {
        this.$message.warning('暂无品质监控数据可保存');
        return;
      }
      this.$confirm('确认保存当前品质监控参数？', this.$t('tishi'), {
        confirmButtonText: this.$t('jixu'),
        cancelButtonText: this.$t('quxiao'),
        type: 'warning'
      }).then(() => {
        this.saveQualityMonitorLoading = true;
        const params = {
          trialMouldWoId: this.yt.editObj.id,
          name: '品质监控参数_' + Date.now(),
          currentStep: '2-1',
          value: JSON.stringify(this.qualityMonitorData)
        };
        this.http
          .post('/web/trial/mould/wo/craft/parameter/create', params)
          .then(() => {
            this.$message.success(this.$t('caozuochenggong'));
          })
          .catch(err => {
            this.$message.error(this.$t(err));
          })
          .finally(() => {
            this.saveQualityMonitorLoading = false;
          });
      }).catch(() => {});
    }
  }
};
</script>
